import clsx from 'clsx';

import { Layout } from 'components/layout';

import { IExtendedCollection } from 'constants/types';

import { CustomMetadata } from 'components/metadata';
import { allMetadata } from 'constants/metadata';
import { allCasinosCollections } from 'constants/routes-breadcrumbs';
import { HeaderCollection } from '../collection-casino-id/header';
import { CasinosLine } from '../home';
import styles from './styles.module.css';

export type Props = {
  collections: IExtendedCollection[];
};

export const AllCollectionsPage = ({ collections }: Props) => {
  return (
    <div className={styles.container}>
      <CustomMetadata
        metadata={
          collections?.[0]?.type === 'casino'
            ? allMetadata.allCasinosCollection
            : allMetadata.allSlotsCollections
        }
      />
      <Layout hasFooter isSearchInputMobileVisible>
        <main className={clsx(styles.main, styles.main_collection)}>
          <HeaderCollection items={[...allCasinosCollections]} />
          {collections?.map((item) => {
            if (item?.type === 'casino') {
              return <CasinosLine key={item._id} collection={item} />;
            }

            return null;
          })}
        </main>
      </Layout>
    </div>
  );
};
